import styled from "styled-components";
const CommentSectionStyle = styled.div`
  background-color: #b3d6e2;
  border-radius: 5px;
  margin: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  h6 {
    padding: 0px;
    margin: 0px;
  }
  p {
    background-color: #ededed;
    border-radius: 5px;
    text-align: justify;
    padding: 5px;
  }
  span {
    display: flex;
    align-items: center;
  }
`;
export default CommentSectionStyle;
